var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#0267C1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3874_23624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 29.4062C17.9125 29.4062 15.3969 28.1125 13.8875 25.8125H17.625V24.375H11.875V30.125H13.3125V27.4656C15.1094 29.6219 17.6969 30.8438 20.5 30.8438V29.4062ZM31.2812 26.5312V25.0938H29.7719C29.7 24.6625 29.4844 24.2313 29.2688 23.8L30.3469 22.7219L29.3406 21.7156L28.2625 22.7937C27.9031 22.5781 27.4719 22.3625 26.9688 22.2906V20.7812H25.5312V22.2906C25.1 22.3625 24.6688 22.5781 24.2375 22.7937L23.1594 21.7156L22.1531 22.7219L23.2312 23.8C23.0156 24.1594 22.8 24.5906 22.7281 25.0938H21.2188V26.5312H22.7281C22.8 26.9625 23.0156 27.3937 23.2312 27.825L22.1531 28.9031L23.1594 29.9094L24.2375 28.8313C24.5969 29.0469 25.0281 29.2625 25.5312 29.3344V30.8438H26.9688V29.3344C27.4 29.2625 27.8312 29.0469 28.2625 28.8313L29.3406 29.9094L30.3469 28.9031L29.2688 27.825C29.4844 27.4656 29.7 27.0344 29.7719 26.5312H31.2812ZM26.25 27.9688C25.0281 27.9688 24.0938 27.0344 24.0938 25.8125C24.0938 24.5906 25.0281 23.6562 26.25 23.6562C27.4719 23.6562 28.4062 24.5906 28.4062 25.8125C28.4062 27.0344 27.4719 27.9688 26.25 27.9688ZM23.375 17.1875H27.1125C24.7406 13.5219 19.8531 12.5156 16.1875 14.8875C13.9594 16.325 12.5938 18.8406 12.5938 21.5H11.1562C11.1562 16.325 15.325 12.1562 20.5 12.1562C23.3031 12.1562 25.8906 13.3781 27.6875 15.5344V12.875H29.125V18.625H23.375V17.1875Z",
    fill: "#0267C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3874_23624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowWidgetIcon);
export default __webpack_public_path__ + "static/media/workflow-widget-icon.41d29a08ffaa1801787fb86d19651c2b.svg";
export { ForwardRef as ReactComponent };